import {allFilters} from '@components/statistics/stats-reports/filter-components'
import {Filter} from '@components/statistics/stats-reports/filter-components/filter'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {TimelineFilter} from 'yougile-model'
import {Util} from 'yougile-util'
import {useStatsTimelineStore} from '../stats-timeline-store'
import {ActionFilterValue} from './filter-action'

const TwFilterRow = tw.div`
  flex
  flex-wrap
  ml-16
`

const TwFilterName = tw.div`
  mr-6
  text-third-old
  text-12
  font-normal
  flex
  items-center
`

export const FilterRow = observer(() => {
  const [state, store] = useStatsTimelineStore()

  const getValue = (filter: Filter, key: keyof TimelineFilter) => {
    if (key === 'action') {
      return <ActionFilterValue filter={state.filter.action} />
    } else {
      return filter.getSelectedValue(state.filter)
    }
  }

  const getName = (filter: Filter, key: keyof TimelineFilter) => {
    switch (key) {
      case 'action':
        return Lang.msg.statsTimeline.actions
      case 'createdBy':
        return Lang.msg.statsTimeline.who
      case 'createdAt':
        return Lang.msg.statsTimeline.when
      case 'located':
        return Lang.msg.statsTimeline.where
      default:
        return filter.getName()
    }
  }

  return (
    <TwFilterRow>
      {store.activeFilter.map((key, ix, {length}) => {
        const filter = allFilters.find(f => f.key === key)
        return (
          <TwFilterName key={ix}>
            <span className="whitespace-nowrap">
              {Util.capitalize(getName(filter, key).toLowerCase())}:
            </span>
            <span className="mr-6" />
            <span className="flex">{getValue(filter, key)}</span>
            <span className="mx-6">{ix + 1 !== length && '|'}</span>
          </TwFilterName>
        )
      })}
    </TwFilterRow>
  )
})
